import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/src/app/[locale]/compare-chatbot-video/PageContent.tsx");
